import React, {ChangeEvent, useState} from 'react';

import {UserFeedback} from 'src/openapi/models/UserFeedback';

import {Button} from '@pb/kit-component-button';
import {Dialog, DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group, Item} from '@pb/kit-component-group';
import {Rating} from '@pb/kit-component-rating';
import {Textarea} from '@pb/kit-component-textarea-v2';

type Props = {
    changeRequestId: number,
    show: boolean,
    setShow: (show: boolean) => void,
    onSendFeedback: (userFeedback: UserFeedback) => void,
};

const PLACEHOLDER_TEXT = 'Share your experience: what worked well with AI Assist and what could be improved';
const MAX_FEEDBACK_LENGTH = 1000;

export const UserFeedbackModalView = (props: Props) => {
    const {
        changeRequestId,
        show,
        setShow,
        onSendFeedback,
    } = props;

    const [rating, setRating] = useState<number>(0);
    const [comment, setComment] = useState<string>('');

    const onChangeComment = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setComment(event.currentTarget.value);
    };

    const onSend = () => {
        if (rating) {
            onSendFeedback({changeRequestId, rating, comment});
        }
    };

    const onClose = () => {
        setShow(false);
    };

    return (
        <Dialog shown={show} setShown={setShow}>
            <Group direction="v" style={{minWidth: 500}}>
                <DialogHeader onClose={onClose}>Feedback Form</DialogHeader>
                <DialogMain>
                    <Group direction="v" className="pdx-m pdy-m">
                        <Group direction="v" alignItems="center">
                            <Item>
                                Please rate your experience with AI Assist and leave your feedback below
                            </Item>
                        </Group>
                        <Group justify="center">
                            <Rating grade={rating} onChange={setRating}/>
                        </Group>
                        <Textarea
                            placeholder={PLACEHOLDER_TEXT}
                            maxLength={MAX_FEEDBACK_LENGTH}
                            onChange={onChangeComment}
                        />
                    </Group>
                </DialogMain>
                <DialogFooter>
                    <Group justify="end" gap="s" style={{width: '100%'}}>
                        <Button variant="Type.SECONDARY" onClick={onClose}>Cancel</Button>
                        <Button variant="Type.PRIMARY" disabled={!rating} onClick={onSend}>Send</Button>
                    </Group>
                </DialogFooter>
            </Group>
        </Dialog>
    );
};
